import { Chip, Grid } from '@mui/material';
import { EntitlementGroupInterface } from '@thro-types/access-handler';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useCoursesQuery } from 'api/hooks/useCoursesQuery';
import { LabeledInput } from 'app/components/RichList/items/CompanyItem/components/LabeledInput';
import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';
import { Course, Faculty } from 'types/AppTypes';

interface Props {
  entitlementGroup: EntitlementGroupInterface;
  faculties: Faculty[];
}

export default function EntitlementGroupDetail(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: courses, isError } = useCoursesQuery();

  useEffect(() => {
    if (isError) {
      dispatch(AlertActions.error(t(translations.pages.modules.alerts.failedLoadingCourses())));
      navigate('/', { replace: true });
    }
  }, [dispatch, isError, navigate, t]);

  const RelationDetail = (courses: Course[], faculties: Faculty[]) => {
    if (props.entitlementGroup.relationType === 'FACULTY') {
      return (
        <Grid item xs={3}>
          <LabeledInput label={t(translations.common.faculty())}>
            {faculties.find(faculty => faculty.id === props.entitlementGroup.faculty)?.shorthand}
          </LabeledInput>
        </Grid>
      );
    } else if (props.entitlementGroup.relationType === 'COURSE') {
      return (
        <Grid item xs={3}>
          <LabeledInput label={t(translations.common.course())}>
            {courses.find(course => course.id === props.entitlementGroup.course)?.shorthand}
          </LabeledInput>
        </Grid>
      );
    }
  };

  return (
    <Grid container>
      <Grid item xs={6}>
        {props.entitlementGroup.name}
      </Grid>
      <Grid item xs={3}>
        <LabeledInput label="Type">
          <Chip label={props.entitlementGroup.relationType} style={{ marginBottom: '0.5em' }} />
        </LabeledInput>
      </Grid>
      {RelationDetail(courses, props.faculties)}
    </Grid>
  );
}
